export const term = {
    "3yearsShort": "3년이내",
    "1yearShort": "1년이내",
    thisSemesterShort: "이번학기",
}
